import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { LogoMark, Wordmark } from "./Logo";
import { scrollToId, EASE } from "@/lib/brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#07090D] pt-24 md:pt-32">
    <img src="/images/hero.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#07090D] via-[#07090D]/60 to-[#07090D]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1, ease: EASE }} className="flex flex-col items-center text-center">
        <LogoMark className="h-16 sm:h-20 w-auto" />
        <Wordmark className="mt-4 text-4xl sm:text-6xl" />
        <p className="mt-4 font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] text-slate-200">Real men • Real conversations • Brighter tomorrows</p>
        <button data-testid="footer-cta-shop" onClick={() => scrollToId("shop")} className="glow-btn mt-10 group">Get yours today <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></button>
      </motion.div>

      <div className="mt-24 grid gap-10 sm:grid-cols-3 border-t border-white/10 pt-10 text-sm">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">Explore</p>
          {[["story", "Our story"], ["shop", "Shop the hoodie"], ["lookbook", "Lookbook"], ["speak-up", "Speak up"]].map(([id, l]) => (
            <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="block py-1 text-slate-200 hover:text-[var(--mth-blue)] transition-colors">{l}</button>
          ))}
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">Need to talk now?</p>
          <a href="tel:116123" data-testid="footer-samaritans-link" className="block py-1 text-slate-200 hover:text-white">Samaritans — 116 123</a>
          <a href="tel:0800585858" data-testid="footer-calm-link" className="block py-1 text-slate-200 hover:text-white">CALM — 0800 58 58 58</a>
          <a href="sms:85258?&body=SHOUT" data-testid="footer-shout-link" className="block py-1 text-slate-200 hover:text-white">Shout — text 85258</a>
        </div>
        <p className="text-slate-300 leading-relaxed">MenTellHealth is a clothing brand. We're not a medical or crisis service — if you're in immediate danger, call 999.</p>
      </div>
      <p aria-hidden="true" className="mt-16 select-none text-center font-display font-black uppercase leading-[0.8] tracking-[-0.04em] text-[13.5vw] text-outline opacity-40">MenTellHealth</p>
      <div className="flex flex-wrap justify-between gap-4 border-t border-white/10 py-6 font-mono text-[11px] uppercase tracking-widest text-slate-400">
        <span>© {new Date().getFullYear()} MenTellHealth</span>
        <span>Talk. Connect. Keep going.</span>
      </div>
    </div>
  </footer>
);
